import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle, setProfileData } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'
import { end_points } from '../../../services/core.index'
import { ApiServiceContext } from '../../../utils/shared.module'

import {
  engine,
  inspection,
  interior,
  light,
  review,
  truck3,
} from '../../../utils/images/imagepath'

function CheckListDetailView() {
  const dispatch = useDispatch()

  const { postData, getData } = useContext(ApiServiceContext)
  const [listData, setCheckListMaster] = useState<any>([])
  const [listTransactionData, setTransactionData] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedValue, setSelectedValue] = useState(null)

  useEffect(() => {
    dispatch(setAppTitle('Check List'))
  }, [])

  // Fetch initial data from API on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      const urls = end_points.getCheckListMaster.url
      const payload: any = {}
      try {
        const response = await postData(urls, payload)
        console.log(response?.data?.data?.checklist_master)
        if (response?.status === 200) {
          setCheckListMaster(response?.data?.data?.checklist_master)
          // const firstObject = response.data[0]
          // setSelectedValue(firstObject.chk_Master_Id) // Set selectedValue with the first object's value
        }
        // const jsonData = await response.json();
        // setInitialArray(jsonData); // Set initialArray state with fetched data
        // setSelectedValue(jsonData.length > 0 ? jsonData[0].value : null); // Set selectedValue with the first object's value
      } catch (error) {
        console.error('Error fetching initial data:', error)
      }
    }

    fetchInitialData()
  }, [])

  useEffect(() => {
    if (selectedValue) {
      const fetchDataFromApi = async () => {
        try {
          let urls2 = end_points.getCheckListTransactions.url
          urls2 += `?transaction_id=1&master_id=${selectedValue}`
          setLoading(true)
          const response = await getData(urls2)

          if (response.status === 200) {
            setTransactionData(response.data)
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      }

      fetchDataFromApi()
    }
  }, [selectedValue])

  const handleClick = (text: any, val: any) => {
    console.log(`Button clicked with parameter: ${text}`)
    console.log(`Button clicked with parameter: ${val}`)
    setSelectedValue(val)
  }

  return (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          <div className='col-sm-6'>
            <h3 className='page-title'>
              Garbage Truck <span>( AB06 CD 1234 )</span>
            </h3>
          </div>
          <div className='col-sm-6'>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item active'>
                <a href='index.html'>Home</a>
              </li>
              <li className='breadcrumb-item active'>
                <a href='truck-list.html'>Truck List</a>
              </li>
              <li className='breadcrumb-item'>Check List</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12'>
          <div className='card truck-info-card success-border'>
            <div className='card-body'>
              <div className='row truck-widget'>
                <div className='col-md-4'>
                  <div className='truck-img'>
                    <img src={truck3} className='img-fluid' alt='Truck' />
                  </div>
                </div>
                <div className='col-md-8'>
                  <div className='truck-list-info'>
                    <div className='truck-details'>
                      <div className='row align-items-center'>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Truck Number</p>
                            <h6>452BG2654</h6>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Driver Name</p>
                            <h6>Cameron Jacob</h6>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Inspector</p>
                            <h6>Christopher Edward</h6>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Company</p>
                            <h6>ABC Company Ltd</h6>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Status</p>
                            <h6>Pending</h6>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='truck-list-text'>
                            <p>Checklist</p>
                            <ul className='nav datas-list'>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-active'></span>
                              </li>
                              <li>
                                <span className='check-list-in-active'></span>
                              </li>
                              <li>
                                <span className='check-list-in-active'></span>
                              </li>
                              <li>
                                <span className='check-list-in-active'></span>
                              </li>
                            </ul>
                            <h5>
                              02/<span>30</span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='truck-list-box'>
                      <div className='row'>
                        <div className='col-md-10'>
                          <div className='truck-list-complete'>
                            <ul className='nav'>
                              <li className='bg-light-success'>
                                <p>Completed Checklist</p>
                                <h6 className='text-success'>02</h6>
                              </li>
                              <li className='bg-light-gray'>
                                <p>Pending Checklist</p>
                                <h6 className='text-gray'>26</h6>
                              </li>
                              <li className='bg-light-danger'>
                                <p>Blacklist Checklist</p>
                                <h6 className='text-danger'>04</h6>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className='col-md-2'>
                          <div className='truck-list-dropdown'>
                            <a
                              href='javascript:void(0);'
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                            >
                              <i className='fas fa-ellipsis-vertical'></i>
                            </a>
                            <div className='dropdown-menu dropdown-menu-end'>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-eye'></i> View
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-edit'></i> Edit
                              </a>
                              <a
                                href='javascript:void(0);'
                                className='dropdown-item'
                              >
                                <i className='feather-trash-2'></i> Delete
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-5'>
          <div className='list-checklist'>
            <div className='list-checklist-title'>
              <h5>Checklist</h5>
              <p>See below to check checklist</p>
            </div>

            <div className='list-checklist-content'>
              <div
                className='checklist-tab nav nav-pills mb-3'
                id='pills-tab'
                role='tablist'
              >
                {listData.map((item: any, index: any) => (
                  <div
                    key={index}
                    className='checklist-nav nav-item checklist-minor'
                  >
                    <div
                      className='checklist-nav-pill'
                      id='pills-overall-tab'
                      data-bs-toggle='pill'
                      data-bs-target='overall-home'
                      role='tab'
                      aria-controls='overall-home'
                      aria-selected='false'
                    >
                      <div className='check-list-img'>
                        <img src={review} alt='checklist' />
                      </div>
                      <div
                        className='checklist-tab-content'
                        onClick={() =>
                          handleClick(
                            item.checklist_Master_Value,
                            item.chk_Master_Id,
                          )
                        }
                      >
                        <div className='cc-checklist-tab'>
                          <h6>{item.checklist_Master_Value}</h6>
                          {/* <div className="content-check">
											<p>{item.content}</p>
											</div> */}
                        </div>
                        <i className='fa-regular fa-circle-check'></i>
                      </div>
                    </div>
                  </div>
                ))}
                {/* <div className="checklist-nav nav-item checklist-completed" role="presentation">
											<div className="checklist-nav-pill nav-link active" id="pills-overall-tab" data-bs-toggle="pill" data-bs-target="#overall-home" type="button" role="tab" aria-controls="overall-home" aria-selected="true">
												<div className="check-list-img">
													<img src={truck3} alt="checklist"/>
												</div>
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Check Overall Appearance</h6>
														<div className="content-check">
															<p>Lorem Ipsum is simply dummy text</p>
														</div>
													</div>
													<i className="fa-regular fa-circle-check"></i>
												</div>
											</div>
										</div>
										<div className="checklist-nav nav-item checklist-minor">
											<div className="checklist-nav-pill" id="pills-review-tab" data-bs-toggle="pill" data-bs-target="#review-tab" role="tab" aria-controls="review-tab" aria-selected="false">
												<div className="check-list-img">
													<img src={review} alt="checklist"/>
												</div>
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Review Previous VIR</h6>
														<div className="content-check">
															<p>It is a long established fact that a reader It is a long established fact that a reader </p>
														</div>
													</div>
													<i className="fa-regular fa-circle-check"></i>
												</div>
											</div>
										</div> */}
                {/* <div className="checklist-nav nav-item">
											<div className="checklist-nav-pill" id="pills-inspection-tab" data-bs-toggle="pill" data-bs-target="#inspection-tab" role="tab" aria-controls="inspection-tab" aria-selected="false">
												<div className="check-list-img">
													<img src={inspection} alt="checklist"/>
												</div>
												
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Walk-around Inspection</h6>
														<div className="content-check">
															<p>There are many variations of passages </p>
														</div>
													</div>
													<i className="fa-regular fa-circle-check"></i>
												</div>
											</div>
										</div>
										<div className="checklist-nav nav-item">
											<div className="checklist-nav-pill" id="pills-light-tab" data-bs-toggle="pill" data-bs-target="#light-tab" role="tab" aria-controls="light-tab" aria-selected="false">
												<div className="check-list-img"> 
													<img src={light} alt="checklist"/>
												</div>
												
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Check Lights</h6>
														<div className="content-check">
															<p>The standard chunk of Lorem Ipsum used. </p>
														</div>
													</div>
													<i className="fa-regular fa-circle-check"></i>
												</div>
											</div>
										</div>
										<div className="checklist-nav nav-item checklist-major">
											<div className="checklist-nav-pill" id="pills-engine-tab" data-bs-toggle="pill" data-bs-target="#engine-tab" role="tab" aria-controls="engine-tab" aria-selected="false">
												<div className="check-list-img">
													<img src={engine} alt="checklist"/>
												</div>
												
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Check Engine</h6>
														<div className="content-check">
															<p>Lorem Ipsum is simply dummy text of the printing </p>
														</div>
													</div>
													<i className="feather-alert-triangle"></i>
												</div>
											</div>
										</div>
										<div className="checklist-nav nav-item">
											<div className="checklist-nav-pill" id="pills-interior-tab" data-bs-toggle="pill" data-bs-target="#interior-tab" role="tab" aria-controls="review-tab" aria-selected="false">
												<div className="check-list-img">
													<img src={interior} alt="checklist"/>
												</div>
												
												<div className="checklist-tab-content">
													<div className="cc-checklist-tab">
														<h6>Inspect Interior</h6>
														<div className="content-check">
															<p>Lorem Ipsum is simply dummy text of the printing </p>
														</div>
													</div>
													<i className="fa-regular fa-circle-check"></i>
												</div>
											</div>
										</div> */}
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-7 mt-4 mt-md-0'>
          <div className='tab-content' id='pills-tabContent'>
            <div
              className='tab-pane fade show active'
              id='overall-home'
              role='tabpanel'
              aria-labelledby='pills-home-tab'
            >
              <div className='checklist-tabinfo-content'>
                <h4>Overall Appearance</h4>
                <div className='step-checklist'>
                  <div className='step-checklist-title'>
                    <div className='cmp-checklist-title'>
                      <h5>Engine Compartment + 1 Axle</h5>
                      <p>4 Checklist</p>
                    </div>
                    <span>4 Completed</span>
                  </div>
                  {listTransactionData.map((section: any, index: number) => (
                    <div key={index} className='step-checklisting'>
                      <h6>{section.Head}</h6>
                      {section.items.map((item: any, idx: number) => (
                        <div key={idx} className='step-checklisting-details'>
                          <div>
                            <span>{idx + 1}</span>
                          </div>
                          <div className='cc-steps-check'>
                            <p>{item.sub_HeadItem}</p>
                            <small>{item.sub_Item}</small>
                            <ul>
                              <li className='no-issues'>No Issues</li>
                              <li>Major</li>
                              <li>Minor</li>
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                  {/* <div className="step-checklisting">
												<h6>3 Fluids</h6>
												<div className="step-checklisting-details">
													<div><span>1</span></div>
													<div className="cc-steps-check">
														<p>Coolant</p>
														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
												<div className="step-checklisting-details">
													<div><span>2</span></div>
													<div className="cc-steps-check">
														<p>Oil</p>
														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
												<div className="step-checklisting-details">
													<div><span>3</span></div>
													<div className="cc-steps-check">
														<p>Power Steering fluid</p>
														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="step-checklisting">
												<h6>3 Components</h6>
												<div className="step-checklisting-details">
													<div><span>1</span></div>
													<div className="cc-steps-check">
														<p>Alternator</p>
														<small>Wires are securely mounted and not frayed. Belt or gear driven, belt has no more than 1/2" to 3/4" of play, no splits or cuts.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
												<div className="step-checklisting-details">
													<div><span>2</span></div>
													<div className="cc-steps-check">
														<p>Water Pump</p>
														<small>Securely mounted, not BBC; not leaking, belt or gear driven, belt has no more than 1/2" to 3/4" inch of play and has no splits or cuts.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
												<div className="step-checklisting-details">
													<div><span>3</span></div>
													<div className="cc-steps-check">
														<p>Air Compressor</p>
														<small>not BBC and must be securely mounted; no audible leaks and belt or gear driven. If belt-driven, belt has no more than 1/2" to 3/4" inch of play and has no splits or cuts.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="step-checklisting">
												<h6>Belts and Hoses</h6>
												<div className="step-checklisting-details">
													<div><span>1</span></div>
													<div className="cc-steps-check">
														<p>Belt and Hoses</p>
														<small>After properly inspecting the power steering hose and the coolant hose, tell the tester that you would inspect all remaining hoses the same way.</small>
														<ul>
															<li className="no-issues">
																No Issues
															</li>
															<li>
																Major
															</li>
															<li>
																Minor
															</li>
														</ul>
													</div>
												</div>
											</div>  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CheckListDetailView
